import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getIntegrationsPath } from "@core/schema/paths/getIntegrationsPath.js";

export function getServicesCrm(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "CRM na míru",
			desc: "Dodáme vám CRM systém vybavený funkcemi a moduly, které potřebujete k hladkému průběhu podnikání. Žádné krabicové řešení, ale vše na míru.",
		},
		{
			title: "Audit CRM systému",
			desc: "Už CRM používáte, ale přijde vám, že to drhne? Provedeme podrobný audit a dáme vám doporučení na zlepšení.",
		},
		{
			title: "Optimalizace CRM systému",
			desc: "Na základě doporučení zvládneme zajistit také optimalizaci a vylepšení vašeho současného CRM systému. I malé změny dokážou udělat divy.",
		},
		{
			title: "Migrace CRM",
			desc: "Postaráme se, aby přechod vaší firmy na nové CRM proběhl hladce a abyste během něj nepřišli o žádná data.",
		},
		{
			title: "Integrace CRM systému",
			desc: `Potřebujete propojit CRM s dalšími nástroji a aplikacemi (např. ERP systém)? Poradíme si s tím, protože s [${getIntegrationsPath(tenant)}][[integrací systémů]] máme letité zkušenosti.`,
		},
		{
			title: "Automatizace CRM",
			desc: "Pomocí automatizace CRM systému vám ušetříme čas a starosti s rutinními procesy při řízení vztahu se zákazníky.",
		},
	];
}
